import { useState } from 'react'
import { Badge, Collapse } from 'reactstrap'
import { useAppSelector } from '../../../../redux/hooks'
import { ChevronDown } from 'react-feather'

const SharedDocument = () => {
  const [isOpen, setIsOpen] = useState(true)
  const { selectedUserProfile } = useAppSelector((state) => state.chat)

  return (
    <div className="document">
      <div className="filter-block">
        <div className="collapse-block profile-collapse-block open">
          <h5 className="block-title" onClick={() => setIsOpen(!isOpen)}>
            Shared Document
            <Badge className="badge-outline-dark sm">{selectedUserProfile?.shared_documents.length}</Badge>
            <div className="chevron_down">
              <ChevronDown />
            </div>
          </h5>
          <Collapse isOpen={isOpen} className="block-content">
            <ul className="document-list">
              {selectedUserProfile && selectedUserProfile?.shared_documents.length > 0 ? (
                selectedUserProfile?.shared_documents.map((item, index) => (
                  <li key={index}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="feather feather-folder font-danger"
                    >
                      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                    </svg>
                    <h6>{item.name}</h6>
                  </li>
                ))
              ) : (
                <p>No Shared Documents</p>
              )}
            </ul>
          </Collapse>
        </div>
      </div>
    </div>
  )
}

export default SharedDocument
